import moment from "moment";

export const Status = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const SSUStatus = {
    DRAFT: "DRAFT",
    DIPROSES: "DIPROSES",
    SELESAI: "SELESAI",
    BATAL: "BATAL",
};

export const MutasiBarangStatus = {
    NEW: "NEW",
    WAITING_APPROVAL: "WAITING_APPROVAL",
    REJECTED_APPROVAL: "REJECTED_APPROVAL",
    PROCESSED: "PROCESSED",
    RECEIVED: "RECEIVED",
    REJECTED: "REJECTED",
    PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
    REJECT_APPROVE: "REJECTED_APPROVAL",
    WAITING_VERIFICATION: "WAITING_VERIFICATION"
};

export const MutasiPartStatus = {
    WAITING_APPROVAL: "WAITING_APPROVAL",
    RECEIVED: "RECEIVED",
    REJECTED: "REJECTED",
    PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
    PROCESSED: "PROCESSED",
    REJECTED_APPROVAL: "REJECTED_APPROVAL",
    WAITING_VERIFICATION: "WAITING_VERIFICATION"
};

export const Level = [
    {
        label: 0,
        value: 0,
    },
    {
        label: 1,
        value: 1,
    },
    {
        label: 2,
        value: 2,
    },
    {
        label: 3,
        value: 3,
    },
    {
        label: 4,
        value: 4,
    },
    {
        label: 5,
        value: 5,
    },
    {
        label: 6,
        value: 6,
    },
    {
        label: 7,
        value: 7,
    },
    {
        label: 8,
        value: 8,
    },
];

export const ACTIVITY_TYPE = {
    CREATE: "CREATE",
    UPDATE: "UPDATE",
    VIEW: "VIEW",
    CANCEL: "CANCEL",
    COPY: "COPY",
    DELETE: "DELETE",
    CORRECTION: "CORRECTION",
};

export const reSignedNumeric = /^-?[^a-zA-Z\s!-\/:-@\[-`{-~]*$/;

export const GenericSequenceType = {
    RECEIVING_UNIT_NOS: "ReceivingUnitNOS",
    RECEIVING_KSU: "ReceivingKsu",
    STOCK_OPNAME: "StockOpname",
    BBN_BPKB_LEASING: "BbnBPKBLeasing",
    TRANSACTION_SAMSAT: "TransactionSamsat",
    TRANSACTION_INDENT_UNIT: "TransactionIndentUnit",
    PAYMENT_BANK_IN: "PaymentBankIN",
    PAYMENT_BANK_OUT: "PaymentBankOUT",
    PAYMENT_CASH_IN: "PaymentCashIN",
    PAYMENT_CASH_OUT: "PaymentCashOUT",
    MANAGEMENT_BOOKING: "ManagementBooking",
    MASTER_SERVICE_PRICE: "MasterServicePrice",
    RECEIVING_ITEMS: "ReceivingOther",
    RECEIVING_GIFT: "ReceivingGift",
    RECEIVING_PART_NOS: "TransactionReceivingPart",
    MANAGEMENT_CLAIM: "ManagementClaim",
    TRANSACTION_PO_PART: "TransactionPoPart",
};

export const Condition = {
    OK: "OK",
    NOT_OK: "NOT_OK",
};

export const PDIStatus = {
    DRAFT: "DRAFT",
    PROSES: "PROSES",
    TOLAK: "TOLAK",
    SELESAI: "SELESAI",
};

export const CashPlan = {
    CASH: "CASH",
    CREDIT: "CREDIT",
};

export const HttpStatus = {
    SUCCESS: "S",
    FAILED: "F",
};

export const DeliveryStatus = {
    NOT_SCANNED: "BELUM_DI_SCAN",
    SCANNED: "SUDAH_DISCAN",
};

export const Pembanding = {
    LEBIH_BESAR: ">",
    LEBIH_BESAR_SAMA_DENGAN: ">=",
    SAMA_DENGAN: "=",
    LEBIH_KECIL: "<",
    LEBIH_KECIL_SAMA_DENGAN: "<=",
};

export const ReportType = {
    SALES_ORDER: "SALES_ORDER",
    SALES_ORDER_BATAL: "SALES_ORDER_BATAL",
    SALES_ORDER_SCP: "SALES_ORDER_SCP",
    SALES_ORDER_SCP_BATAL: "SALES_ORDER_SCP_BATAL",
    UNIT_REPORT_SO: "UNIT_REPORT_SO",
    UNIT_KEKURANGAN_SO: "UNIT_KEKURANGAN_SO",
    UNIT_KELEBIHAN_SO: "UNIT_KELEBIHAN_SO",
    UNIT_SUMMARY_SO: "UNIT_SUMMARY_SO",
    KSU_REPORT_SO: "KSU_REPORT_SO",
    KSU_KEKURANGAN_SO: "KSU_KEKURANGAN_SO",
    KSU_KELEBIHAN_SO: "KSU_KELEBIHAN_SO",
    KSU_SUMMARY_SO: "KSU_SUMMARY_SO",
    SAMSAT: "SAMSAT",
    BBN_LEASING: "BBN_LEASING",
    COVER_NOTE: "COVER_NOTE",
}

export const INITIAL_PAGINATION = {
    limit: 5,
    page: 1,
    totalData: 0
}

export const INITIAL_DATE = moment().format("DD-MM-YYYY")